<template>
  <div>
    <CusModal
      @handleCancel="onClose"
      @handleOk="onClickConfirm"
      title="Chỉnh sửa đơn remote"
      :isShow="isShow"
    >
      <ValidationObserver
        tag="form"
        ref="formCreate"
        @submit.prevent="onClickConfirm()"
      >
        <CRow class="form-input">
          <CCol md="6" class="form-field">
            <label class="form-label">
              {{ $t("label.id_code") }}
            </label>
            <b-form-input
              type="text"
              v-model="forms.employee_id"
              placeholder="employee id"
              disabled
            />
          </CCol>
          <CCol md="6" class="form-field" v-if="userRemoteInfo.userInfo.name">
            <label class="form-label">
              {{ $t("label.full_name") }}
            </label>
            <b-form-input
              type="text"
              v-model="userRemoteInfo.userInfo.name"
              placeholder="employee name"
              disabled
            />
          </CCol>
        </CRow>

        <CRow class="form-input">
          <CCol md="6" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_approve_person1") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="overtime.approve"
            >
              <select
                class="form-control"
                v-model="forms.approve_person_1"
                v-if="
                  approvalPerson['level1'] &&
                  approvalPerson['level1'].length > 0
                "
              >
                <option
                  v-for="(option, index) in approvalPerson['level1']"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <select
                class="form-control"
                v-model="forms.approve_person_1"
                v-else
              >
                <option
                  v-for="(option, index) in approvalPerson['level1']"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
          <CCol
            md="6"
            class="form-field"
            v-if="
              approvalPerson['level2'] && approvalPerson['level2'].length > 0
            "
          >
            <label class="form-label">
              {{ $t("commons.label_approve_person2") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="overtime.approve2"
            >
              <select
                class="form-control"
                v-model="forms.approve_person_2"
                v-if="approvalPerson['level2']"
              >
                <option
                  v-for="(option, index) in approvalPerson['level2']"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <select
                class="form-control"
                v-model="forms.approve_person_2"
                v-else
              >
                <option
                  v-for="(option, index) in approvalPerson['level2']"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>

        <CRow class="form-input">
          <!-- <CCol md="6" class="form-field">
          <label class="form-label">
            {{ $t("overtime.start_time") }}
            <span class="require">*</span>
          </label>
          <ValidationProvider
            :rules="{
              required: true,
              regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
            }"
            v-slot="{ errors }"
            name="overtime.start_time"
          >
            <b-form-input
              type="text"
              v-model="forms.start_time"
              v-mask="'##:##'"
              placeholder="HH:mm"
            />
            <span class="required">{{ errors[0] }}</span>
          </ValidationProvider>
        </CCol> -->
          <CCol md="6" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_start_date") }}
              <span class="require">*</span>
            </label>
            <div>
              <ValidationProvider
                :rules="{
                  required: true,
                }"
                v-slot="{ errors }"
                name="remote.label_start_date"
              >
                <a-date-picker
                  :disabled-date="disabledStartDate"
                  format="DD/MM/YYYY"
                  v-model="startDate"
                  :placeholder="$t('overtime.date')"
                  @change="onChangeStartDate"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </CCol>
          <!-- </CRow> -->

          <!-- <CRow class="form-input">
        <CCol md="6" class="form-field">
          <label class="form-label">
            {{ $t("overtime.end_time") }}
            <span class="require">*</span>
          </label>
          <ValidationProvider
            :rules="{
              required: true,
              regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
            }"
            v-slot="{ errors }"
            name="overtime.end_time"
          >
            <b-form-input
              type="text"
              v-model="forms.end_time"
              v-mask="'##:##'"
              placeholder="HH:mm"
            />
            <span class="required">{{ errors[0] }}</span>
          </ValidationProvider>
        </CCol> -->
          <CCol md="6" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_end_date") }}
              <span class="require">*</span>
            </label>
            <div>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="remote.label_end_date"
              >
                <a-date-picker
                  :disabled-date="disabledEndDate"
                  format="DD/MM/YYYY"
                  v-model="endDate"
                  :placeholder="$t('overtime.date')"
                  @change="onChangeEndDate"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </CCol>
        </CRow>

        <!-- <CRow class="form-input">
        <CCol md="6" class="form-field">
          <label class="form-label">
            {{ $t("remote.label.number_day_remote") }}
          </label>
          <b-form-input
            type="text"
            v-model="forms.number_days_remote"
            disabled
          />
        </CCol>
      </CRow> -->

        <CRow class="form-input">
          <CCol md="12" class="form-field">
            <label class="form-label">
              {{ $t("commons.label_reason") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required|max:255"
              v-slot="{ errors }"
              name="overtime.reason"
            >
              <b-form-textarea
                class="textarea-input"
                id="textarea"
                rows="6"
                max-rows="8"
                placeholder="Nhập lý do xin làm remote"
                v-model="forms.reason"
              >
              </b-form-textarea>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>
      </ValidationObserver>
    </CusModal>
    <CusModal
      @handleCancel="hidePopupNoti"
      @handleOk="hidePopupNoti"
      :title="$t('error.error') + '!'"
      :isShow="isShowPopupNoti"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ popupNoti }}
        </div>
      </div>
    </CusModal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CusModal from "@/components/commons/CusModal.vue";
import _ from "lodash";

export default {
  name: "EditRemoteRequestModal",
  components: {
    ValidationObserver,
    ValidationProvider,
    CusModal,
  },
  computed: {
    ...mapGetters({
      requestInfo: "remote-request/requestInfo",
      userRemoteInfo: "remote-request/userInfo",
    }),
  },
  beforeDestroy() {
    this.clearData();
  },
  watch: {},
  data() {
    return {
      isShow: false,
      isShowPopupNoti: false,
      popupNoti: "",
      forms: {
        id: "",
        employee_id: "",
        approve_person_1: "",
        approve_person_2: "",
        start_date: null,
        end_date: null,
        // start_time: null,
        // end_time: null,
        // number_days_remote: 0,
        reason: "",
      },
      startDate: null,
      endDate: null,
      approvalPerson: {
        level1: [],
        level2: [],
      },
    };
  },

  methods: {
    ...mapActions("remote-request", [
      "getUserRemoteInfo",
      "clearData",
      "getRemoteRequestInfo",
      "updateRemoteRequest"
    ]),
    moment,
    async open(request_id) {
      if (request_id) {

        if (_.isEmpty(this.userRemoteInfo)) {
          await this.getRemoteInfo();
        }
        //initial approve list
        const { listPM, listManager } = { ...this.userRemoteInfo };
        if (_.isEmpty(listPM)) {
          if (_.isEmpty(listManager)) {
            this.popupNoti = "Hiện tại bạn không có người duyệt đơn remote";
            this.isShowPopupNoti = true;
            return;
          } else {
            this.approvalPerson["level1"] = listManager;
          }
        } else {
          this.approvalPerson["level1"] = listPM;
          this.approvalPerson["level2"] = listManager;
        }

        //initial form data
        await this.getRemoteRequestById(request_id);
        this.initialRemoteInfo();
        this.isShow = true;
      } else {
        this.popupNoti = "Không tồn tại request ID";
        this.isShowPopupNoti = true;
      }
    },
    async onClickConfirm() {
      const isValid = await this.$refs.formCreate.validate();
      if (!isValid) return;
      await this.updateUserRemoteRequest();
    },
    onClose() {
      this.resetForm();
      this.$refs.formCreate.reset();
      this.isShow = false;
    },
    onChangeStartDate(date) {
      this.forms.start_date = date.format("DD/MM/YYYY");
    },
    onChangeEndDate(date) {
      this.forms.end_date = date.format("DD/MM/YYYY");
    },
    disabledStartDate(current) {
      if (this.endDate) {
        return (
          current < moment().subtract(1, "days") ||
          current > moment(this.endDate)
          // || moment(current).isSameOrAfter(moment(), "day")
        );
      }
      return (
        current < moment().subtract(1, "days")
        // || moment(current).isSameOrAfter(moment(), "day")
      );
    },
    disabledEndDate(current) {
      if (this.startDate) {
        return (
          current < moment(this.startDate, "DD/MM/YYYY")
          // || moment(current).isSameOrAfter(moment(), "day")
        );
      }
      return (
        current < moment().subtract(1, "days")
        // || moment(current).isSameOrAfter(moment(), "day")
      );
    },
    resetForm() {
      const formData = {
        id: "",
        approve_person_1: "",
        approve_person_2: "",
        start_date: null,
        end_date: null,
        reason: "",
      };
      (this.startDate = null), (this.endDate = null);
      this.forms = { ...this.forms, ...formData };
    },
    hidePopupNoti() {
      this.isShowPopupNoti = false;
    },
    async getRemoteRequestById(id) {
      await this.getRemoteRequestInfo(id);
    },
    async getRemoteInfo() {
      await this.getUserRemoteInfo();
    },

    initialRemoteInfo() {
      // console.log(this.requestInfo);
      const formData = {
        id: this.requestInfo.id,
        employee_id: this.requestInfo.employee_id,
        start_date: this.requestInfo.start_date,
        end_date: this.requestInfo.end_date,
        reason: this.requestInfo.note,
        approve_person_1: this.requestInfo?.approve_person_1 || this.approvalPerson.level1[0]?.id,
        approve_person_2: this.requestInfo?.approve_person_2 || this.approvalPerson.level2[0]?.id,
      };
      this.startDate = moment(this.requestInfo.start_date, "DD/MM/YYYY");
      this.endDate = moment(this.requestInfo.end_date, "DD/MM/YYYY");
      this.forms = formData;
    },
     async updateUserRemoteRequest() {
      this.$root.$loading.start();
      await this.updateRemoteRequest(this.forms)
        .then(() => {
          let message = this.$t("overtime.message_update_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          //todo
          this.$emit("getData");
          // this.$emit("fetchTotalRequest");
          // this.$store.dispatch("commons/getCountRequest");
          this.resetForm();
          this.$refs.formCreate.reset();
          this.isShow = false;
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  margin-bottom: 16px;
  .form-field {
    .form-label {
      font-weight: 700;
      font-size: 14px;
      color: #303c54;

      .require {
        color: #f03d3e;
      }
    }

    /deep/ .ant-calendar-picker {
      width: 100%;

      .ant-input {
        height: 35px;
      }
    }

    .textarea-input {
      border: 1px solid #cfcfcf;
      border-radius: 10px;
    }

    .required {
      color: #f03d3e;
    }
  }
}
/deep/ .modal-content {
  border: unset;
  .warning-title {
    text-align: center;
  }
}
</style>

